var exports = {
  "k": "x93eb46d8--6be3f7--container",
};

module.exports = exports;
